<template>
  <div>
    <XDateType
      v-if="showDateType"
      :label="labelIcon('fa/light/play')"
      icon="fa/light/play"
      :date="reaction.relativeDate"
    />

    <XCard>
      <XVideoPlayer
        slot="header"
        :playsinline="true"
        :options="playerOptions"
      />

      <XReactionFooter
        v-if="shareChannels"
        :reaction="reaction"
        :shareChannels="shareChannels"
        :shareMessage="shareMessage"
        :shareHashtags="shareHashtags"
        :shareDescription="shareDescription"
        :allowExpressions="allowExpressions"
        :showShare="showShare"
        :showExpressions="showExpressions"
      />
    </XCard>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'

import { videoPlayer } from 'vue-video-player'

import ReactionMixin from './ReactionMixin'

export default {
  mixins: [
    ReactionMixin
  ],

  components: {
    'XVideoPlayer': videoPlayer
  },

  data () {
    return {
      playerOptions: {
        language: 'es',
        sources: [{
          type: 'video/mp4',
          src: this.reaction.url
        }]
      }
    }
  }
}
</script>
